import { Injectable, isDevMode } from "@angular/core";
import { Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@api";
import { JwtHelperService } from "@auth0/angular-jwt";
import { CountdownService } from "@core/Services/countdown.service";
import { StorageMap } from "@ngx-pwa/local-storage";
import { lastValueFrom, map } from "rxjs";

@Injectable({
    providedIn: 'root',
  })
  export class AuthGuard  {


    constructor(
      private auth: AuthService,
      protected storage : StorageMap,
      private router: Router,
      ) {}
    canActivate(state: RouterStateSnapshot) {

      if(this.router.url.includes('exhibitor/kzGOzLWB')){
        return true
      }else{
        return this.storage.get('token').pipe(
          map((token:any)=>{
            if(token){

              token = JSON.parse(atob(token))

              this.auth.token = token.access_token;
              //console.log('im roooooooot');

              if(isDevMode()){
                //console.log('[token]',token);
              }
              return true;

            } else {
              this.auth.token = false;
              this.router.navigateByUrl('/login?redirect='+state.url);
              return false
            }
          })
        )
      }

    }

  }

  //MARK:INIT GUARD
@Injectable({
  providedIn: "root",
})
export class InitGuard {
  validation = new JwtHelperService();

  constructor(
    protected storage: StorageMap,
    private auth: AuthService,
    private countdown: CountdownService
  ) {}
  canActivate() {
    if (isDevMode()) {
      //console.log("init guard");
    }

    const params = new URLSearchParams(window.location.search);
    const bypass = params.get("bypass");

    if (bypass) {
      lastValueFrom(this.storage.set("bypass", true));
    }

    lastValueFrom(this.storage.get("bypass")).then((data) => {
      if (!data) {
        // this.countdown.getDataCountdown();
      } else {
        // this.countdown.timer = -1
        this.countdown.resetCountdown();
        // this.auth.bypass = true;
      }
    });

    return this.storage.get("token").pipe(
      map(async (token: any) => {
        if (token) {

          token = atob(token)

          let isExipred = this.validation.isTokenExpired(token);

          if (isExipred) {
            this.auth.logout();

            return false;
          } else {
            //console.log(token)

            token = JSON.parse(token)

            //console.log(token.access_token)
            this.auth.token = token.access_token;

            let user = await this.auth.getDataUsers();
            if (user) {
              this.auth.user = user;
            }
            return true;
          }
        } else {
          this.auth.token = false;
          return true;
        }
      })
    );
  }
}
